const LocalStorage = {
  AUTH_TOKEN: '@pre_op_token',
  USER: '@pre_op_user',
  TOKEN: '@pre_op_tok',
  PATIENT: '@pre_op_patient',
};

export default LocalStorage;